<template>
  <div class="dashboard">
    <Films></Films>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Films from "@/pages/films/List";
export default {
  name: "CompanyDashboard",
  components: {
    Films
  },
  created() {
    this.fetchTags();
    this.fetchFilms();
  },
  computed: {
    ...mapGetters({
      filters: "filter/getApplied",
      is_filters_applied: "filter/is_applied"
    })
  },
  methods: {
    async fetchTags() {
      await this.$store.dispatch("tag/list");
      await this.$store.dispatch("tag/listCountries");
    },

    async fetchFilms() {
      if (this.is_filters_applied) {
        var self = this;
        this.$store.dispatch("filter/listFilms", this.filters);
      } else {
        this.$store.dispatch("film/list");
      }
    }
  }
};
</script>
